import * as React from 'react';

import { IBreadcrumbSchema } from '../../repositories/countryside-search/entities/breadcrumbs/BreadcrumbSchema';
import { getMicrodataAttributes } from '../../utils/seo';

import * as styles from './Breadcrumbs.css';

export interface IBreadcrumbsProps {
  breadcrumbs: IBreadcrumbSchema[];
  divider?: React.ReactNode;
}

export const Breadcrumbs: React.VFC<IBreadcrumbsProps> = ({ breadcrumbs, divider = ' / ' }) => {
  if (!breadcrumbs) {
    return null;
  }

  const breadcrumbsToRender = breadcrumbs.map((breadcrumb, index) => {
    const url = breadcrumb.seo?.url || '';

    return (
      <span {...getMicrodataAttributes('ListItem')} itemProp="itemListElement" key={`breadcrumb_${index}`}>
        {url ? (
          <a href={url} title={breadcrumb.title} itemProp="item" className={styles['link']}>
            <span itemProp="name">{breadcrumb.title}</span>
          </a>
        ) : (
          <span itemProp="name" className={styles['link']}>
            {breadcrumb.title}
          </span>
        )}
        {index < breadcrumbs.length - 1 && divider}
        <meta itemProp="position" content={`${index + 1}`} />
      </span>
    );
  });

  return (
    <div {...getMicrodataAttributes('BreadcrumbList')} className={styles['breadcrumbs']}>
      {breadcrumbsToRender}
    </div>
  );
};
